import script from "./Proxies.vue?vue&type=script&setup=true&lang=js"
export * from "./Proxies.vue?vue&type=script&setup=true&lang=js"

import "./Proxies.vue?vue&type=style&index=0&id=6b07ff54&lang=scss&scoped=true"

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b07ff54"]])

export default __exports__